let ipInfoCache = null;

async function fetchIpInfo() {
  if (ipInfoCache) return ipInfoCache;

  const token = process.env.GATSBY_IP_INFO_TOKEN;
  if (!token) return null;

  try {
    const response = await fetch(`https://ipinfo.io/json?token=${token}`);
    ipInfoCache = await response.json();
    return ipInfoCache;
  } catch {
    return null;
  }
}

export async function getCountryCodeFromIpInfo() {
  const data = await fetchIpInfo();
  return data?.country?.trim()?.toUpperCase() || "IN";
}

export function getCountryNameFromCode(countryCode) {
  if (!countryCode) return null;

  try {
    return (
      new Intl.DisplayNames(["en"], { type: "region" }).of(countryCode) ||
      countryCode
    );
  } catch {
    return countryCode;
  }
}

export async function getCountryNameFromIpInfo() {
  const data = await fetchIpInfo();
  const countryCode = data?.country?.trim()?.toUpperCase();
  if (!countryCode) return null;
  return getCountryNameFromCode(countryCode);
}
